import axios from 'axios';
import { ENV } from "../utils";

const baseURL = ENV.BASE_PATH;
const idLegacy = ENV.CHANNEL_ID;
const idOpera = ENV.OPERA_ID;
const paymentsURL = ENV.PAYMENTS;


export const getDebt = async (documentType, documentNumber, numeroReferencia, producto) => {
  try {
    const response = await axios.get(`${baseURL}/recaudo/deuda`, {
      params: {
        tipoDocumento: documentType,
        numeroDocumento: documentNumber,
        numeroReferencia: numeroReferencia,
        idProducto: producto,
        idCanal: idLegacy
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al consultar la deuda');
  }
};


export const getOperaDebts = async (documentType, documentNumber, numeroReferencia, idLegado, hotel) => {
  try {
    const response = await axios.get(`${baseURL}/recaudo/opera`, {
      params: {
        tipoDocumento: documentType,
        numeroDocumento: documentNumber,
        idlegado: idLegado.key,
        idCanal: idOpera,
        idReferencia: numeroReferencia,
        terminal: hotel
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al consultar la deuda');
  }
};


export const getEducationDebt = async (documentType, documentNumber, numeroReferencia) => {
  try {
    const response = await axios.get(`${baseURL}/recaudo/deuda/educacion`, {
      params: {
        tipoDocumento: documentType,
        numeroDocumento: documentNumber,
        numeroReferencia: numeroReferencia,
        idCanal: idLegacy
      },
    });
    return response.data;
  } catch (error) {
    throw new Error('Error al consultar las deudas');
  }
};


export async function getPayment(payload) {
  try {
    const response = await axios.post(paymentsURL, payload);
    return response.data.obtenerTransaccion; 
  } catch (error) {
    console.error('Error al consultar el pago:', error);
    throw new Error('Error al consultar el pago'); 
  }
};


export const validateDebt = async (payload) => {
  try {
    const response = await axios.post(`${baseURL}/pagos/validacion`, payload);
    return response.data;
  } catch (error) {
    throw new Error('Error al crear el pago');
  }
};

export const payDebt = async (payload) => {
  try {
    const response = await axios.post(`${baseURL}/pagos/tokenizado`, payload);
    return response.data;
  } catch (error) {
    throw new Error('Error al crear el pago');
  }
};
